module.exports = __webpack_public_path__ + "static/img/mask.79f1ada1.png";